import { motion } from "framer-motion";
import { InstagramLogo, Heart, DeviceMobile } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_f92832a4-f773-4854-853a-afbb4cec93dc/artifacts/hfvgmn1m_JS%20Blond%20Logo%20white.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2C2C2C] text-white py-16">
      <div className="container-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <motion.img
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              src={LOGO_URL}
              alt="JS Blond Salon"
              className="h-16 w-auto mb-6"
            />
            <p className="text-white/60 font-light leading-relaxed max-w-md mb-6">
              Premium Blond, gepflegte Ergebnisse und ein klarer Ablauf – für 
              Kundinnen und Friseur/innen in Leingarten.
            </p>
            <div className="flex flex-wrap gap-3">
              <motion.a
                href="https://www.phorest.com/salon/jsblondsalonughaftungsbeschrae"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-book-btn"
                className="inline-block bg-[#D4AF37] text-[#2C2C2C] px-8 py-4 rounded-full uppercase tracking-widest text-xs font-bold hover:bg-white transition-colors duration-300"
                whileHover={{ scale: 1.05 }}
              >
                Termin Buchen
              </motion.a>
              <Link to="/app">
                <motion.div
                  data-testid="footer-app-btn"
                  className="inline-flex items-center gap-2 bg-white/10 text-white px-6 py-4 rounded-full uppercase tracking-widest text-xs font-bold hover:bg-white hover:text-[#2C2C2C] transition-colors duration-300 cursor-pointer"
                  whileHover={{ scale: 1.05 }}
                >
                  <DeviceMobile size={16} weight="fill" />
                  Zur App
                </motion.div>
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm uppercase tracking-widest mb-6 text-white/80">
              Navigation
            </h3>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Services", path: "/services" },
                { label: "Co-Working", path: "/coworking" },
                { label: "Education", path: "/education" },
                { label: "Kontakt", path: "/kontakt" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-nav-${link.path.replace('/', '') || 'home'}`}
                    className="text-white/60 hover:text-white transition-colors font-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm uppercase tracking-widest mb-6 text-white/80">
              Rechtliches
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/impressum"
                  data-testid="footer-legal-impressum"
                  className="text-white/60 hover:text-white transition-colors font-light"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/agb"
                  data-testid="footer-legal-agb"
                  className="text-white/60 hover:text-white transition-colors font-light"
                >
                  AGB & Salonregeln
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  data-testid="footer-legal-datenschutz"
                  className="text-white/60 hover:text-white transition-colors font-light"
                >
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-sm uppercase tracking-widest mb-6 text-white/80">
              Folge uns
            </h3>
            <div className="space-y-3">
              <a
                href="https://www.instagram.com/jsblondsalon"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <InstagramLogo size={20} weight="fill" />
                <span className="font-light">@jsblondsalon</span>
              </a>
              <a
                href="https://www.instagram.com/jennifervallentin"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/60 hover:text-white transition-colors"
              >
                <InstagramLogo size={20} weight="fill" />
                <span className="font-light">@jennifervallentin</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm font-light">
              © {currentYear} JS Blond Salon. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/impressum"
                data-testid="footer-impressum-link"
                className="text-white/40 text-sm font-light hover:text-white transition-colors"
              >
                Impressum
              </Link>
              <Link
                to="/agb"
                data-testid="footer-agb-link"
                className="text-white/40 text-sm font-light hover:text-white transition-colors"
              >
                AGB
              </Link>
              <p className="text-white/40 text-sm font-light flex items-center gap-2">
                Made with <Heart size={16} weight="fill" className="text-[#D4AF37]" /> in Leingarten
              </p>
              <Link
                to="/admin"
                className="text-white/20 text-xs font-light hover:text-white/60 transition-colors"
              >
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
